import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { ROUTES } from '../constants';
import { Modal } from './Modal';

export const SuccessSubmitModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      title={
        <FormattedMessage
          id='addService.successMessage'
          defaultMessage='Ваша заявка отправлена'
        />
      }
      isOpen={isOpen}
      onClose={() => onClose()}
    >
      <FormattedMessage
        id='addService.successMessageDetails'
        defaultMessage='Ваша заявка успешно отправлена! Мы рассмотрим её в течение 24 часов.'
      />
      <div className='flex items-center space-x-2'>
        <button
          type='button'
          onClick={() => onClose()}
          className='mt-4 px-6 py-2 text-white rounded-lg focus:outline-none bg-blue-600 hover:bg-blue-700'
        >
          <FormattedMessage
            id='addService.successMessageDetailsButton.back'
            defaultMessage='Назад'
          />
        </button>
        <Link to={ROUTES.profile}>
          <button
            type='button'
            className='mt-4 px-6 py-2 text-white rounded-lg focus:outline-none bg-blue-600 hover:bg-blue-700'
          >
            <FormattedMessage
              id='addService.successMessageDetailsButton.goToProfile'
              defaultMessage='Профиль'
            />
          </button>
        </Link>
      </div>
    </Modal>
  );
};
